import { usePackageBookingStore } from "@elixir/stores";
import { PACKAGE_POPUP_TYPE } from "@elixir/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { postRedeemPackage } from "apis";
import { getAllQueuesQuery } from "../get-all-queues";
import { getPackageDetailsByTransctionIdKey } from "./use-get-package-details-by-transaction-id";

const usePostRedeemPacakge = () => {
  const queryClient = useQueryClient();
  const setPackagePopupType = usePackageBookingStore(
    (state) => state.setPackagePopupType
  );

  return useMutation(postRedeemPackage, {
    onSuccess: ({ success }) => {
      if (success) {
        setPackagePopupType(PACKAGE_POPUP_TYPE.NONE);
        queryClient.invalidateQueries(getPackageDetailsByTransctionIdKey());
        notification.success({
          message: "Success",
          description: "Package redeemed successfully",
          placement: "bottomRight",
        });
      } else {
        notification.error({
          message: "Error",
          description: "Failed to redeem package",
          placement: "bottomRight",
        });
      }
    },
  });
};
export default usePostRedeemPacakge;
